import PortalFields from "./PortalFields";
import PortalDocument from "../../document/PortalDocument";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export default class FieldGroup {
	private readonly fields: Array<PortalFields>;

	constructor(fields?: Array<PortalFields>) {
		this.fields = FunctionHelper.applyValue(fields, []);
	}

	public getDefaults(): PortalFields | undefined {
		return this.fields[this.fields.length - 1];
	}

	public get(documents: Array<PortalDocument>): PortalFields | undefined {
		for (let field of this.fields.values()) {
			if (field.isSupported(documents)) {
				return field;
			}
		}
	}
}